// extracted by mini-css-extract-plugin
module.exports = {"space":"Cancelados1_space__2pVDZ","pendienteReversion":"Cancelados1_pendienteReversion__1kBYA","pagoReversado":"Cancelados1_pagoReversado__2YULI"};